import $ from "jquery";
import router from "@/router"; // 引入router
import Vue from "vue";
import sha1 from "js-sha1";

import { setToken, scrollTop } from "@/libs/util";
import until from "./until";
// function setTop(){
//   if (document.getElementById('contentTop')) {
//     document.getElementById('contentTop').scrollTop = 0;
//   }
// }

// function getVuePro() {
//   return this;
// }

let _loadingConfig = {
  countLoading: 0,
  loading: ""
};
/*
  config.headers
  config.otherParams: json, 覆盖原有的请求配置，如content-type等
*/
export const ajax = function(
  method,
  url,
  param,
  config = {
    otherParams: {
      contentType: "application/x-www-form-urlencoded"
    }
  }
) {
  return new Promise(function(resolve, reject) {
    // const selfGlobal = getVuePro.call(Vue.prototype).$selfGlobal;
    const selfGlobal = Vue.prototype.$selfGlobal;
    if (config && config.method) {
      selfGlobal &&
        selfGlobal.$globalRequestMeth.methodList.push(config.method);
    }
    // 处理loading
    if (param && !param.noLoading) {
      if (_loadingConfig.countLoading <= 0) {
        _loadingConfig.loading = Vue.$loading.show({
          width: 50,
          height: 50,
          color: "#2d8cf0",
          zIndex: 1030
        });
      }
      _loadingConfig.countLoading += 1;
    }
    // 设置header
    let headers = handleRequestHeader(config);

    $.ajax({
      method: method,
      url: url,
      data: param,
      headers: headers,
      dataType: "json",
      crossDomain: true,
      contentType: config.contentType || "application/x-www-form-urlencoded",
      timeout: 60 * 100000, // 响应超时时间1min *1000-- 1.6h *10000
      // traditional: true,
      // xhrFields: {
      //   withCredentials: true,
      // },
      ...config.otherParams,
      success: function(data, status, response) {
        const getResToken =
          response.getResponseHeader("token") ||
          response.getResponseHeader("Token");
        if (response && getResToken) {
          localStorage.setItem("token", getResToken);
        }
        handleRequestError(data, { reject, resolve });
      },
      error: function(error) {
        console.log(error);
        // const $Message = getVuePro.call(Vue.prototype).$Message;
        const $Message = Vue.prototype.$Message;
        const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
        handleRequestError(error, { reject, resolve });
        reject({
          code: error.code
        });
      },
      complete() {
        if (param && !param.noLoading && _loadingConfig.countLoading > 0) {
          _loadingConfig.countLoading -= 1;
        }
        if (_loadingConfig.countLoading <= 0) {
          // Vue.$loading.show();
          // Vue.$loading.hide();
          _loadingConfig.loading && _loadingConfig.loading.hide();
        }
      }
    });
  });
};

function handleRequestError(data, { reject, resolve }) {
  const selfGlobal = Vue.prototype.$selfGlobal;
  const getCode = data.status || Number(data.code) || 0; // 404是data.status; Number(data.code)需要放在后面，因为有可能是0请求超时
  switch (getCode) {
    case 1000:
    case 1001:
      localStorage.removeItem("token");
      localStorage.removeItem("user_type");
      localStorage.removeItem("username");
      // this.$store.commit('setNewMenuList', [])
      // this.$store.commit('SETPUBLICSIDEMENU', []);
      Vue.prototype.$Message.error(
        data.operationMessage || data.message || "Login failed"
      );
      reject &&
        reject({
          code: getCode
        });
      if (router.history && router.history.current.path !== "/login") {
        router.replace({
          path: "/login"
        });
      }
      break;
    case 10001:
    case 10002:
    case 10004:
    case 501:
    case 502:
    case 503:
      // getVuePro.call(Vue.prototype).$Message.error(data.message);
      Vue.prototype.$Message.error(
        data.operationMessage ||
          selfGlobal.$globalI18n.tc("js.request.requestFail")
      );
      reject &&
        reject({
          code: getCode
        });
      break;
    case 10005:
      localStorage.removeItem("token");
      localStorage.removeItem("user_type");
      localStorage.removeItem("username");
      router.replace({
        path: "/login"
      });
      break;
    case 200:
      resolve && resolve(data);
      break;
    case 404:
      Vue.prototype.$Message.error("Request 404");
      reject &&
        reject({
          code: getCode
        });
      break;
    case 0:
      if (data.statusText === "timeout")
        Vue.prototype.$Message.error(
          selfGlobal.$globalI18n.tc("js.request.timeOut")
        );
      else
        Vue.prototype.$Message.error(
          selfGlobal.$globalI18n.tc("js.request.requestFail")
        );
      break;
    default:
      Vue.prototype.$Message.error(
        data.operationMessage ||
          data.message ||
          selfGlobal.$globalI18n.tc("js.request.unknownMis")
      );
      reject &&
        reject({
          code: getCode
        });
  }
}

function handleRequestHeader(config) {
  // 设置header
  const timestamp = parseInt(new Date().getTime() / 1000);
  const nonce = until.getNonce();
  const dis = "operation1258236";
  let headers = {
    token: localStorage.getItem("token") || "",
    timestamp, // 时间戳
    nonce, // 随机数字
    signature: sha1(timestamp + dis + nonce) // sha1加密结果
  };
  if (config && config.headers) {
    headers = Object.assign({}, headers, config.headers);
  }
  return headers;
}

export const uploadImg = function(url, param) {
  return new Promise(function(resolve, reject) {
    if (param && !param.noLoading) {
      if (_loadingConfig.countLoading <= 0) {
        _loadingConfig.loading = Vue.$loading.show({
          width: 50,
          height: 50,
          color: "#2d8cf0",
          zIndex: 1030
        });
      }
      _loadingConfig.countLoading += 1;
    }
    let headers = handleRequestHeader();
    $.ajax({
      method: "post",
      url: url,
      data: param,
      processData: false,
      contentType: false,
      headers: headers,
      async: true,
      dataType: "json",
      timeout: 3600 * 1000, // 单位毫秒 响应超时时间 1h
      success: function(data) {
        resolve(data);
      },
      error: function(error) {
        const $Message = Vue.prototype.$Message;
        const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
        switch (error.code) {
          case 408:
            $Message.error($globalI18n.tc("js.request.timeOut"));
            break;
          case 0:
            if (error.statusText === "timeout")
              $Message.error($globalI18n.tc("js.request.timeOut"));
            break;
        }
        reject(error);
      },
      complete: function() {
        if (param && !param.noLoading && _loadingConfig.countLoading > 0) {
          _loadingConfig.countLoading -= 1;
        }
        if (_loadingConfig.countLoading <= 0) {
          // Vue.$loading.show();
          // Vue.$loading.hide();
          _loadingConfig.loading && _loadingConfig.loading.hide();
        }
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/js/request.js